import React from 'react';
import Nav from './navbar'
import Footer from './footer'
import Contact from './Contact'
import Education from './education'
import Skills from './skills'
import Ratings from './ratings';
import AboutMe from './about'
import Project from './project'
import Intro from './intro'

export default function Home() {
  return (
    <>
    <Nav/>
    <Intro/>
    <AboutMe/>
    <Project/>
    <Skills/>
    <Ratings/>
    <Education/>
    <Contact/>
    <Footer/>
    </>
  )
}

